import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3Icon, ShieldIcon, TrendingUpIcon } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-white" data-id="element-11">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-13">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-navy mb-6" data-id="element-14">
            About the Team
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-16">
            <div className="relative" data-id="element-17">
              <div className="aspect-square rounded-lg overflow-hidden bg-gradient-to-br from-navy to-charcoal" data-id="element-18">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=800&auto=format&fit=crop" alt="Trevor Williams" className="w-full h-full object-cover opacity-90" data-id="element-19" />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-gold text-navy px-6 py-3 rounded-lg font-bold" data-id="element-20">
                Founder & Principal
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-21">
            <h3 className="text-3xl font-serif font-bold text-navy mb-4" data-id="element-22">
              Trevor Williams
            </h3>
            <p className="text-lg text-slate mb-6 leading-relaxed" data-id="element-23">
              Trevor has spent over a decade analyzing and investing in Cabo San
              Lucas real estate. His approach is rooted in data, not hype —
              every deal recommendation is backed by quantified metrics and
              independent research.
            </p>
            <p className="text-lg text-slate mb-6 leading-relaxed" data-id="element-24">
              Before launching Cabo Deal Flow, Trevor worked with private family
              offices and high-net-worth individuals to source off-market
              opportunities across Mexico's Pacific coast. He recognized a gap
              in the market: sophisticated investors needed curated,
              institutional-grade deal flow without the noise of traditional
              listing sites.
            </p>

            <div className="space-y-4 mt-8" data-id="element-25">
              <div className="flex items-start" data-id="element-26">
                <BarChart3Icon className="text-gold mr-3 mt-1 flex-shrink-0" size={24} data-id="element-27" />
                <div data-id="element-28">
                  <h4 className="font-semibold text-navy mb-1" data-id="element-29">
                    Data-Driven Philosophy
                  </h4>
                  <p className="text-slate text-sm" data-id="element-30">
                    Every deal is evaluated on cash flow, ROI, and equity
                    potential — not marketing narratives.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-31">
                <ShieldIcon className="text-gold mr-3 mt-1 flex-shrink-0" size={24} data-id="element-32" />
                <div data-id="element-33">
                  <h4 className="font-semibold text-navy mb-1" data-id="element-34">
                    Privacy-First Approach
                  </h4>
                  <p className="text-slate text-sm" data-id="element-35">
                    No cold calls, no spam. Investors control the relationship
                    and engage when ready.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-36">
                <TrendingUpIcon className="text-gold mr-3 mt-1 flex-shrink-0" size={24} data-id="element-37" />
                <div data-id="element-38">
                  <h4 className="font-semibold text-navy mb-1" data-id="element-39">
                    Investor-First Mindset
                  </h4>
                  <p className="text-slate text-sm" data-id="element-40">
                    Focused on long-term relationships and sustainable returns,
                    not quick commissions.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}